import Button from './Button';

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
}

export default function ErrorState({ title = 'Hiba történt', description = 'Az adatok betöltése sikertelen.', onRetry }: ErrorStateProps) {
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'var(--space-3)',
        padding: 'var(--space-10)',
        textAlign: 'center',
        color: 'var(--slate)',
      }}
    >
      <span style={{ fontSize: '32px', lineHeight: 1 }} aria-hidden="true">⚠️</span>
      <div>
        <p style={{ fontWeight: 700, color: 'var(--red)', marginBottom: 'var(--space-1)' }}>{title}</p>
        <p style={{ fontSize: '13px' }}>{description}</p>
      </div>
      {onRetry && (
        <Button variant="ghost" onClick={onRetry} size="sm">Újrapróbálás</Button>
      )}
    </div>
  );
}
